import { EMP_INFO_SYSTEM_NAME } from '../constants/StandardEmploymentInformationSystemName.js';
import type { TaetigkeitsBaseData } from './TaetigkeitsBaseData.js';

export const Berufsabschluss = [
  {
    [EMP_INFO_SYSTEM_NAME]: 2,
    Bezeichnung: 'Abschluss einer anerkannten Berufsausbildung',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 9,
    Bezeichnung: 'Abschluss unbekannt',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 4,
    Bezeichnung: 'Bachelor',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 5,
    Bezeichnung: 'Diplom/Magister/Master/Staatsexamen',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 3,
    Bezeichnung: 'Meister-/Techniker- oder gleichwertiger Fachschulabschluss',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 1,
    Bezeichnung: 'Ohne beruflichen Ausbildungsabschluss',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 6,
    Bezeichnung: 'Promotion',
  },
] satisfies TaetigkeitsBaseData;
